export const MIN_TIER_LIMIT = 0;
export const MAX_TIER_LIMIT = 999999999;

export const UNLIMITED_FIELD = "unlimited";
export const TIERS_FIELD = "tiers";
